<template>
  <v-carousel
    height="600"
    :hide-delimiter-background="true"
    delimiter-icon="mdi-checkbox-blank"
    :show-arrows="false"
  >
    <v-carousel-item
      v-for="(slide, i) in slides"
      :key="i"
    >
      <div class="slider">
        <h1 class="slider__title">{{ slide.title }}</h1>
        <p class="slider__text">
          {{ slide.content }}
        </p>
        <img
          class="slider__img"
          :src="require(`@/assets/img/${slide.img}`)"
          alt="Joins us image" />
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      slides: [
        {
          title: 'Payment warranty',
          content: 'No worries about your money - Bench is a warrantee for both sides of the contract.',
          img: 'slider-1.svg',
        },
        {
          title: 'Effortless contract',
          content: 'Bench handles all the paperwork and so you can focus on your work.',
          img: 'slider-2.svg',
        },
        {
          title: 'New equipment & co-working space',
          content: 'Need equipment or working space? Worry not - our partners are here for you in 260 cities. For free.',
          img: 'slider-3.svg',
        },
        {
          title: 'Your personal manager',
          content: 'Let your personal manager be there for you to help you grow as a developer and a person.',
          img: 'slider-4.svg',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scope>
.slider {
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 600px;

  &__title {
    font-size: 28px;
    margin-bottom: 12px;
    color: $main--text;
    margin-top: 14px;
  }

  &__text {
    line-height: 28px;
    margin-bottom: 20px;
    color: $main--text;
    opacity: 0.7;
    font-size: 14px;
    @include desktop {
      margin-bottom: 100px;
    }
  }

  &__img {
    max-width: 100%;
    margin: auto 0;
  }
}
</style>
